import type { CachedTeamPatternsResponse, PatternsResponse } from '@lms/shared-types'
import { apiRequest } from './client'

export interface AnalyzePatternsInput {
  employeeId: string
  windowDays?: number
}

export function analyzePatterns(input: AnalyzePatternsInput): Promise<PatternsResponse> {
  return apiRequest<PatternsResponse>('/api/v1/leaves/patterns', {
    method: 'POST',
    body: { employeeId: input.employeeId, windowDays: input.windowDays ?? 90 },
  })
}

/**
 * Cached team patterns. `teamId` narrows the response to one team — the api
 * honours it for HR+ (managers/HODs are always scoped to their own reports/
 * team and ignore it). The "My team" board passes the viewer's own team so
 * HR sees their team, not the whole company; the HR overview board omits it
 * to keep the company-wide view.
 */
export function getCachedTeamPatterns(
  teamId?: string,
): Promise<CachedTeamPatternsResponse> {
  const qs = teamId ? `?teamId=${encodeURIComponent(teamId)}` : ''
  return apiRequest<CachedTeamPatternsResponse>(`/api/v1/leaves/patterns/team${qs}`)
}
